import AWS from 'aws-sdk';

export default class S3Service {
  constructor(bucketRegion, bucketName, accessKeyId, secretAccessKey) {
    this.bucketName = bucketName;

    AWS.config.update({
      region: bucketRegion,
      accessKeyId,
      secretAccessKey,
    });

    this.s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      params: {
        Bucket: this.bucketName,
      },
    });
  }

  videoKey(originalFilename, uuid) {
    const prefixOfUUID = uuid.substr(0, 2);
    const safeFilename = originalFilename.replace(/[^A-Za-z0-9_\\.\-]/gi, '_');
    return `${prefixOfUUID}/${uuid}/${safeFilename}`;
  }

  thumbnailKey(originalFilename, uuid) {
    const prefixOfUUID = uuid.substr(0, 2);
    const safeFilename = originalFilename.replace(/[^A-Za-z0-9_\\.\-]/gi, '_');
    const base = this.baseName(safeFilename);
    return `${prefixOfUUID}/${uuid}/${base}_thumbnail.jpg`;
  }

  uploadFile(key, file, callback) {
    const upload = this.s3.upload({
      Key: key,
      Body: file,
      ACL: 'public-read',
    });
    if (callback) {
      upload.on('httpUploadProgress', (event) => {
        const progress = (event.loaded * 100) / event.total;
        callback(progress, event.loaded, event.total);
      });
    }
    return upload;
  }


  //------ Helper functions
  baseName(str) {
    var base = new String(str).substring(str.lastIndexOf('/') + 1);
    if (base.lastIndexOf(".") !== -1)
      base = base.substring(0, base.lastIndexOf("."));
    return base;
  }
}
